import React, { FC, ReactNode } from 'react';
import { dataAttribsForEl, formatClassName, DataAttribsForElParams } from '../../../utils';
import { Image as CoreImage, Layout as CoreLayout } from '../../../core';
import { tokens } from '@everfi/design-system';

export type CardMediaBoxProps = Partial<{
  chakra?: string;
  className: string;
  hasLabel: boolean;
  mediaAspectRatio?: number;
  mediaBackground: 'white' | 'gray' | 'light';
  mediaContent: ReactNode;
  mediaDataAttributes: DataAttribsForElParams;
  mediaPosition: 'left' | 'right' | 'center';
  mediaSize: 'icon' | 'small' | 'large' | 'full';
  mediaUrl: string;
  type: string;
}>;

export const CardMediaBox: FC<CardMediaBoxProps> = props => {
  const {
    chakra = 'on',
    className,
    hasLabel,
    mediaAspectRatio,
    mediaBackground = 'white',
    mediaContent,
    mediaDataAttributes: { context = {}, optionalAttributes } = {},
    mediaPosition = 'left',
    mediaSize = 'large',
    mediaUrl,
    type = 'wide',
  } = props;
  const mediaClasses = formatClassName([
    className,
    'card-media',
    `card-media-${type}`,
    `card-media-${mediaSize}`,
    `card-media-${mediaPosition}`,
    `card-media-${mediaBackground}`,
    { 'has-label': hasLabel },
  ]);
  const dataAttributes = dataAttribsForEl(context, optionalAttributes);

  return chakra === 'on' ? (
    <div {...dataAttributes}>
      {mediaContent ||
        (mediaUrl && (
          <CoreLayout
            borderRadius={mediaSize !== 'full' ? tokens.BorderRadiiLg : 0}
            overflow="hidden"
            variant="flex"
            justifyContent={mediaPosition}
          >
            <CoreImage path={mediaUrl} aspectRatio={mediaAspectRatio} />
          </CoreLayout>
        ))}
    </div>
  ) : (
    <div className={mediaClasses} {...dataAttributes}>
      {mediaContent || <img src={mediaUrl} alt="Card Image" />}
    </div>
  );
};

CardMediaBox.displayName = 'CardMediaBox';
